import { Boundaries } from "@planzone/core";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { State } from "./types";

function handleRequest(
  state: State,
  planzone: Boundaries["retrieveZones"]["request"],
): State {
  const index = state.findIndex((req) => req.planzone.uuid === planzone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...state[index],
          request: setRequestStateToPending(),
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          planzone,
          zones: [],
          request: setRequestStateToPending(),
        },
      ];
}

export { handleRequest };
